import { atom } from 'jotai';

import { Space } from '../models/space';

export const availableSpacesAtom = atom<Space[]>([]);
